import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'incoterms'

export const dataPointDefinition = {
  retracedId: 'incoterms',
  name: 'Incoterms',
  description: 'Incoterms (2020 standard set) published by the International Chamber of Commerce (ICC). It defines standardized trade terms that specify how costs, risks, transport, and responsibilities are divided between buyers and sellers.',
  meta: {},
  fieldTypeId: 'MULTI_SELECT',
  type: 'TRANSACTIONAL',
  options: [
    {
      key: 'EXW',
      text: 'EXW – Ex Works',
    },
    {
      key: 'FCA',
      text: 'FCA – Free Carrier',
    },
    {
      key: 'FAS',
      text: 'FAS – Free Alongside Ship',
    },
    {
      key: 'FOB',
      text: 'FOB – Free on Board',
    },
    {
      key: 'CFR',
      text: 'CFR – Cost and Freight',
    },
    {
      key: 'CIF',
      text: 'CIF – Cost, Insurance and Freight',
    },
    {
      key: 'CPT',
      text: 'CPT – Carriage Paid To',
    },
    {
      key: 'CIP',
      text: 'CIP – Carriage and Insurance Paid To',
    },
    {
      key: 'DAP',
      text: 'DAP – Delivered at Place',
    },
    {
      key: 'DPU',
      text: 'DPU – Delivered at Place Unloaded',
    },
    {
      key: 'DDP',
      text: 'DDP – Delivered Duty Paid',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 38020,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
